export default {
      id: "chocolates-usage",
      viewBox: "0 0 37 31",
      url: __webpack_public_path__ + "img/icons.svg#chocolates",
      toString: function () {
        return this.url;
      }
    }